import * as React from 'react';
import { TransitionProps } from '../Transition/Transition.types';

export interface CollapseProps {
  dataHook?: string;
  children?: React.ReactNode;
  open?: boolean;
  mountOnEnter?: TransitionProps['mountOnEnter'];
  unmountOnExit?: TransitionProps['unmountOnExit'];
  onExpandAnimationEnd?: TransitionProps['onStart'];
  onCollapseAnimationEnd?: TransitionProps['onEnd'];
}

export default class Collapse extends React.Component<CollapseProps> {}
